import { createContext, useContext, useEffect } from "react";

/** `focus` blendet zusätzlich die Kopfzeile über dem Inhalt und den oberen/seitlichen Innenrand aus. */
export type AppShellWorkspaceRequest = { focus: boolean };

/** Vom `AppShell` bereitgestellt; liefert zur Anforderung die Freigabe zurück. */
export const AppShellWorkspaceContext = createContext<((request: AppShellWorkspaceRequest) => () => void) | null>(null);

/**
 * Arbeitsflächen fordern vorübergehend Platz an: Solange mindestens eine Anforderung aktiv ist, klappt die
 * Navigation ein. Selbst wieder aufgeklappt bleibt sie offen, bis die letzte Anforderung endet; der gespeicherte
 * Menüzustand des Produkts bleibt unberührt.
 */
export function useAppShellWorkspace(active: boolean, options?: { focus?: boolean }) {
  const request = useContext(AppShellWorkspaceContext);
  const focus = options?.focus ?? false;
  useEffect(() => (active && request ? request({ focus }) : undefined), [active, focus, request]);
}
